import React from 'react';

export default function Brands({ data }) {
  return (
    <div className="cs_brands cs_style_1">
      {data.map((item, index) => (
        <div className="cs_brand" key={index}>
          {item.href ? (
            <a href={item.href} target="_blank" rel="noopener noreferrer">
              <img src={item.logoSrc} alt={item.logoAlt} className="brand-logo" />
            </a>
          ) : (
            <img src={item.logoSrc} alt={item.logoAlt} className="brand-logo" />
          )}
        </div>
      ))}
    </div>
  );
}